import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eou4scycuf: FaireBrandEntity = {
  token: "b_eou4scycuf",
  type: "brand",
  name: "Waku",
  avatarUrl:
    "https://cdn.faire.com/fastly/76d0edf161532a53eff084627288fadf2b5be348c010466450bdd786f88844f2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9a16d025814cb40e5c5995b346debcca07c1b1715d1f84852f1bc7f932e593ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/76d0edf161532a53eff084627288fadf2b5be348c010466450bdd786f88844f2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9a16d025814cb40e5c5995b346debcca07c1b1715d1f84852f1bc7f932e593ed.jpeg",
  location: "Somerville, MA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "We are Waku! The new generation of tea, bringing pop and fun to the traditional RTD tea category. Waku has the same fruity, sweet, refreshing taste but with only 3-4 grams of sugar, 25 calories, and prebiotic fiber to maximize the gut-health benefits!\n\n\nIn Ecuador, two pals, Nico and Juan, forged a bond back in middle school. While in college, they were fueled with entrepreneurial fire, and before long, they were inseparable.\n\nBut the real adventure began when they teamed up at a previous job. Juan and Nico weren't just co-workers; they were kindred spirits with a shared dream: to shake things up and make a positive dent in their homeland's economy. With Ecuador's knack for growing top-notch natural goodies, they saw a golden opportunity to lift up local farmers and shake off poverty's grip.\n\nTheir journey took them through the rugged Andes Mountains in search of the elusive \"horchata lojana\" recipe. After sampling 52 teas, they struck gold. With a sprinkle of (investment magic), they founded Waku, a brand dedicated to blending tradition with innovation.\n\nBut it wasn't just about brewing tea; it was about brewing change. They uprooted themselves and planted their dream in Boston, MA. Today, Waku isn't just a brand; it's a feeling. With thousands of satisfied customers on Amazon and shelf space all throughout the Northeast region, Juan and Nico are spreading shine, one sip at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:38.662Z",
    importedBy: "entity-db-cli",
  },
};
